<template>
    <VuelidateWrapper
        :name="name"
        :value="value"
        :status="status"
        @clear-error="e => $emit('clear-error', e)"
        @input="e => $emit('input', e)"
    >
        <template
            v-slot:default="{
                internalStatus,
                statusMessage,
                input,
                validationValue
            }"
        >
            <div class="LongFormInput">
                <FieldLabel
                    :for="$attrs.id"
                    :label="label"
                    :label-tooltip="labelTooltip"
                    :disabled="disabled"
                    :status="internalStatus"
                />
                <textarea
                    :id="$attrs.id"
                    ref="input"
                    :class="classBuilder('LongFormInput__input', internalStatus)"
                    :placeholder="placeholder"
                    :value="validationValue"
                    :disabled="disable"
                    @input="e => input(e.target.value)"
                />
                <span
                    v-if="showCount(internalStatus)"
                    class="LongFormInput__count"
                >{{ getCount(validationValue) }}</span>
                <span
                    v-if="showMessage(internalStatus, statusMessage)"
                    :class="classBuilder('LongFormInput__status', internalStatus)"
                >{{ statusMessage }}</span>
            </div>
        </template>
    </VuelidateWrapper>
</template>
<script>
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';
import has from 'lodash/has';
import VuelidateWrapper from './VuelidateWrapper';
import FieldLabel from 'components/Basic/Elements/FieldLabel.vue';

export default {
    name: 'RPLongFormInput',
    components: {
        FieldLabel,
        VuelidateWrapper
    },
    props: {
        /**
         * @model
         */
        value: {
            type: [String, Object],
            required: true,
            validator: val => {
                return typeof val === 'string'
                || has(val, '$model');
            }
        },
        /**
         * A label to display in validation error messages
         */
        name: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: null,
        },
        labelTooltip: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
        counter: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        disable(){
            return this.disabled || this.status === stat.LOADING;
        },

    },
    methods: {
        focus(){
            this.$refs.input.focus();
        },
        showCount(status){
            return status === stat.STANDBY
                && this.count !== ''
                && this.counter;
        },
        getCount(val){
            let temp = `${val.length} Characters`;
            if(val.split(' ').length - 1) {
                temp += ` - ${val.split(' ').length } Words`;
            }
            return temp;
        },
        showMessage(status, message){
            return status !== stat.STANDBY
                && message !== '';
        },
        classBuilder(className, status){
            return statusBuilder(
                className,
                status,
                this.disabled
            );
        },
    }
};
</script>
<style lang="scss">
    .LongFormInput {
        position: relative;
        width: 100%;
        &__input {
            min-height: 5rem;
            width: 100%;
            height: 100%;
            padding: 0.5rem;
            border: 1px solid $grey-100;
            border-radius: 4px;

            @include loading(5rem, 100%);

            &--error {
                border-color: $error-red;
            }
            &--warning {
                border-color: $warning-yellow;
            }
            &--success {
                border-color: $success-green;
            }
        }
        &__count,
        &__status {
            position: absolute;
            font-size: 0.7rem;
            bottom: 0.5rem;
            left: 0.75rem;
        }
        &__count {
            color: $text-grey;
        }
        &__status {
            color: $text-grey;
            &--error {
                color: $error-red;
            }
            &--warning {
                color: $warning-yellow;
            }
            &--success {
                color: $success-green;
            }
        }
    }
</style>

<docs>
```[import](./RPLongFormInputExample.vue)
```
</docs>
